import React from 'react'
import { Link } from 'react-router-dom'
import './styles.scss'

const CategorySquaredCard = (props) => {
  const { category } = props
  if (!category.reel || !category.reelMobile) return null
  return (
    <figure className='category-squared-card'>
      <Link
        to={`/${category.category_alias}/explorar`}
        aria-label={`Ver todos los programas de ${category.category}`}
      >
        <picture>
          <source
            srcSet={category.reelMobile}
            media='(max-width: 767px)'
          />
          <img
            src={category.reel}
            alt={`Reel de ${category.category}`}
          />
        </picture>
      </Link>
    </figure>
  )
}

export default CategorySquaredCard
